import area from './area';
import auditor from './auditor';
import contragent from './contragent';
import district from './district';
import executive from './executive';
import house from './house';
import inspection from './inspection';
import locality from './locality';
import personcontragent from './personcontragent';
import province from './province';
import street from './street';
import zvt from './zvt';
import user from './user';
import objectexamination from './ObjectExamination';
import localUser from './localUser';

const cat = {
  area,
  auditor,
  contragent,
  district,
  executive,
  house,
  inspection,
  locality,
  personcontragent,
  province,
  street,
  zvt,
  user,
  objectexamination,
  localUser,
};

export default cat;
